import { registerLocaleData } from '@angular/common';
import localeZhHant from '@angular/common/locales/zh-Hant';
import {
  enableProdMode,
  importProvidersFrom,
  LOCALE_ID,
  isDevMode,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, TitleStrategy } from '@angular/router';
import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routes';
import { MaterialModule } from './app/shared/material/material.module';
import { environment } from './environments/environment';
import { provideHttpClient } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { SwUpdateService } from '@core/services/sw-update.service';
import { MumuPageTitleStrategy } from '@core/configs/mumu-page-title-strategy';
import { provideFirebase } from '@core/firebase';

registerLocaleData(localeZhHant);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    { provide: LOCALE_ID, useValue: 'zh-Hant' },
    provideRouter(APP_ROUTES),
    { provide: TitleStrategy, useClass: MumuPageTitleStrategy },
    provideHttpClient(),
    provideFirebase(
      environment.firebase,
      environment.useEmulator,
      environment.appCheckSiteKey
        ? { siteKey: environment.appCheckSiteKey, debug: !environment.production }
        : undefined
    ),
    importProvidersFrom(MaterialModule),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideAppInitializer(() => {
      const initializerFn = ((swUpdateService: SwUpdateService) => () => {
        swUpdateService.init();
      })(inject(SwUpdateService));
      return initializerFn();
    }),
  ],
});
